import DocumentNode from "./DocumentNode";

export default function RowNode({ data, index: rowIndex, style }) {
  const {
    rows,
    selectedPageContexts,
    toggleSelectedPageContexts,
    setSelectedPageContexts,
    onClassify,
    onPageDrop,
    onSplit,
    onDelete,
    selectedDocumentIndex,
    setSelectedDocumentIndex,
  } = data;
  const row = rows[rowIndex];
  return (
    <div style={style}>
      <div className="flex px-1 gap-1">
        {row.documentContexts.map((context) => {
          const { documentIndex, document } = context;
          return (
            <DocumentNode
              key={documentIndex}
              documentIndex={documentIndex}
              document={document}
              selectedPageContexts={selectedPageContexts}
              toggleSelectedPageContexts={toggleSelectedPageContexts}
              setSelectedPageContexts={setSelectedPageContexts}
              onClassify={onClassify}
              onPageDrop={onPageDrop}
              onSplit={onSplit}
              onDelete={onDelete}
              onClick={() => setSelectedDocumentIndex(documentIndex)}
              selected={documentIndex === selectedDocumentIndex}
            />
          );
        })}
      </div>
    </div>
  );
}
